import { objectReduce } from '@helpers/ObjectHelpers';

const MIN_QUERY_LENGTH = 1;

const cleanNumber = (number) => {
  return number ? number.replace(/Nr /g, '') : '';
};

export function parsePlaceDetails(placeDetails) {
  if (!placeDetails) return {};

  const {
    placeId: id, streetName: street, streetNumber: number, city, province, geo
  } = placeDetails;

  const { lat, long: lng } = geo || {};

  return {
    id, street, number: cleanNumber(number), city, province, lat, lng
  };
}

export function checkStreetNumber(newNumber, prevNumber) {
  if (prevNumber === newNumber) return true;

  try {
    if (newNumber.toString().includes('-')) {
      const [lowerString, upperString] = newNumber.toString().split('-');
      const prev = parseInt(prevNumber.toString().replace(/\D/g, ''), 10);
      const lower = parseInt(lowerString.replace(/\D/g, ''), 10);
      const upper = parseInt(upperString.replace(/\D/g, ''), 10);
      if (prev >= lower && prev <= upper) return true;
    } else {
      return true;
    }
  } catch (err) {
    console.error('Failed to parse street number', err);
  }

  return false;
}

export function arePlaceSearchParamsValid(params) {
  const { id, ...rest } = params || {};
  return !!id || Object.values(rest).some((v) => !!v);
}

export function getPlaceSearchAddress(params) {
  return encodeURIComponent(
    Object.values(params)
      .filter((v) => !!v)
      .join(' ')
  );
}

export function getPlaceSearchQuery(params) {
  return objectReduce(
    params,
    (acc, key, value, index) => {
      const prefix = index !== 0 ? '&' : '';
      const current = value ? `${key}=${encodeURIComponent(value)}` : '';
      return `${acc}${prefix}${current}`;
    }
  );
}

export function isPlaceQueryValid(query) {
  return query?.length >= MIN_QUERY_LENGTH;
}

export function areGeolocationParamsValid(params) {
  const { lat, lng } = params || {};
  return !!lat && !!lng;
}
